import loginBackground from 'assets/images/plutoIntroImage_lowres.png';
import { PageBackground, PageContainer } from 'pages/Intro/Intro.styled';
import { IntroHeader } from 'pages/Intro/IntroHeader/IntroHeader';
import { IntroPageContent } from 'pages/Intro/IntroPageContent/IntroPageContent';

export const IntroMobile = () => {
  return (
    <PageContainer>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      ></div>
      <PageBackground
        style={{
          backgroundImage: `url(${loginBackground})`,
        }}
      >
        <IntroHeader isMobile={true} />
        <IntroPageContent isMobile={true} />
      </PageBackground>
    </PageContainer>
  );
};
